import { StyleSheet } from "@react-pdf/renderer";

export const termsAndConditionStyles = StyleSheet.create({
    page: {
        padding: "10px 20px",
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: "#ffffff",
    },
    logoImage: {
        width: "auto",
        height: "55px",
    },
    tableCol: {
        width: "100%",
        borderWidth: 0,
        padding: "3px 0 2px 2px",
        textAlign: "center",
    },
    termsAndConditionTableRow: {
        flexDirection: "row",
    },
    headingTableCell: {
        fontSize: 9,
        color: '#000811',
    },
    contentTableCell: {
        fontSize: 7,
        textAlign: "justify",
        color: '#000811',
        lineHeight: '9px'
    },
    subHeading:
    {
        fontSize: 7,
        textAlign: "left",
        color: '#000811',
        marginTop: "5px"
    },
    subContentTableCell: {
        fontSize: 7,
        textAlign: "justify",
        color: '#63707E',
        lineHeight: '9px'
    },
    subContentBulletPointsTableCell: {
        fontSize: 7,
        textAlign: "justify",
        color: '#63707E',
        lineHeight: '9px',
        listStyleType: "disc outside none",
        display: "list-item",
        paddingTop: "8px",
        paddingLeft: "10px"
    },
    subContentBulletImage: {
        display: "flex",
    },
    bulletImage: {
        width: "3px",
        height: "3px",
    }
});